import { render, staticRenderFns } from "./DialogSign.vue?vue&type=template&id=0d134eda&scoped=true&"
import script from "./DialogSign.vue?vue&type=script&lang=js&"
export * from "./DialogSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d134eda",
  null
  
)

export default component.exports